import React, { Component } from "react";
import { BaseComponent } from "BaseComponent";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { DropdownButton, Dropdown } from "react-bootstrap";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE, maxLengthObjectFc } from "Constants";
import LocaleStrings from "Languages";
import { confirmAlert } from "react-confirm-alert";
import { deleteAllSchedule } from "ContentActions";
import BetaFeature from "BetaFeature";

class ScheduleDelete extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = { loading: false };
  }

  deleteAllSessions(e) {
    confirmAlert({
      title: LocaleStrings.session_title_delete,
      message: LocaleStrings.session_text_are_you_sure_delete,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteAllSchedule(
              this.props.session,
              "sessions",
              (response) => {
                if (response.success === 0) {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  this.props.showSuccess(LocaleStrings.session_message_deleted);
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  deleteAllTracks() {
    confirmAlert({
      title: LocaleStrings.track_title_delete,
      message: LocaleStrings.track_text_are_you_sure_delete,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteAllSchedule(
              this.props.session,
              "tracks",
              (response) => {
                if (response.success === 0) {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  this.props.showSuccess(LocaleStrings.track_message_deleted);
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  render() {
    return (
      <div className="dropdown-btn-container">
        <DropdownButton
          className="dropdown-blue-btn"
          title={LocaleStrings.schedule_button_deleteall}
          key="1"
          id="dropdown-basic-2"
          nocaret="true"
        >
          <Dropdown.Item
            value="sessions"
            onClick={(e) => this.deleteAllSessions(e)}
          >
            {LocaleStrings.schedule_button_deleteall_sessions}
            <span className="ps-1">
              <BetaFeature />
            </span>
          </Dropdown.Item>
          <Dropdown.Item
            value="tracks"
            onClick={(e) => this.deleteAllTracks(e)}
          >
            {LocaleStrings.schedule_button_deleteall_tracks}
            <span className="ps-1">
              <BetaFeature />
            </span>
          </Dropdown.Item>
        </DropdownButton>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps, {
  deleteAllSchedule,
  showError,
  showSuccess,
})(
  reduxForm({
    form: "ScheduleDeleteForm",
    enableReinitialize: true,
  })(ScheduleDelete)
);
